// extracted by mini-css-extract-plugin
export default {"gallery":"c-p_fz","gallery__header":"c-p_fA","gallery__thumbs":"c-p_fB"};